module.exports = __webpack_public_path__ + "static/assets/4647578196eea45e0bbb6d75d565fd8d.jpg";